import { reactive, ref, computed, watch, onMounted } from '@vue/composition-api'
import store from '@/store'
import * as apiQA from '@/api/qa'

/**
 * 書籍情報取得ウィンドウ
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    book_title: computed(() => {
      return props.parentGroup1.bookTitle
    }),
    qa_title: computed(() => {
      return props.parentGroup1.qaTitle
    }),

    // タイトルが改行されている場合は、1行目の文字列と、2行目以降の文字列のリストに分離する

    qa_title_first_line: computed(() => {
      const title = group1.qa_title
      let qaTitleFirstLine = ''
      if (typeof title !== 'undefined') {
        const arr = title.split(/\r?\n/)
        for (let i = 0; i < arr.length; i++) {
          if (i === 0) {
            qaTitleFirstLine = arr[i]
          } else {
          }
        }
      }
      return qaTitleFirstLine
    }),
    qa_title_after_second_lines: computed(() => {
      const title = group1.qa_title
      const qaTitleAfterSecondLines = []
      if (typeof title !== 'undefined') {
        const arr = title.split(/\r?\n/)
        for (let i = 0; i < arr.length; i++) {
          if (i === 0) {
          } else {
            qaTitleAfterSecondLines.push(arr[i])
          }
        }
      }
      return qaTitleAfterSecondLines
    }),

    author: computed(() => {
      return props.parentGroup1.book_author
    }),
    manual_recomentation: computed(() => {
      return props.parentGroup1.book_manual_recomentation
    }),
    book_publication_date: computed(() => {
      return props.parentGroup1.book_publication_date
    })

  })

  return group1
}
